export enum LinkedDataManualLoader {
  OFX = 'ofx',
}
